import React from "react";
import * as UIConstants from "../UIConstants";
import { Link } from "react-router-dom";
import ReactTable from "../../../react-table-atis";
import { FormControl } from "react-bootstrap";
import CellStatus from "./CellStatus";
import { Tooltip } from "react-tippy";
import { isA, isReporter } from "../../../store/utility";
import axios from "../../../axios-atis";
import { ToastContainer, toast } from "react-toastify";
import { 
  dateSort, 
  numberFilterMethod, 
  userIdFilterMethod,
  selectFilterMethodInt,
  planningUserIdOptions,
  statusOptions,
  sectionOptions,
  companyOptions } from "../helper";
import { Checkbox } from "react-bootstrap";
import CallDoneModal from "../../../containers/Modal/CallDoneModal";
import { siteFilterOptions } from "./siteFilter"; // ATIS-RECHERCHE-SITE 28/10/2026
import FilBadge from "./FilBadge"; // 04/11/2026 (registre n° 39) : échanges client
import { lienFil, rafraichirEtats } from "../../../store/external/fil"; // 04/11/2026 (registre n° 39)

class RequestTable extends React.PureComponent {
  columnsCache = null;
  lastCompaniesKey = null;

  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      selectedCompany: null,
      filtered: sessionStorage.getItem("requestFilters") !== null ? JSON.parse(sessionStorage.getItem("requestFilters")) : [],
      sorted: sessionStorage.getItem("requestSorts") !== null ? JSON.parse(sessionStorage.getItem("requestSorts")) : [],
      callDoneRequest: null,
      callDoneSending: false,
    };
  }
  componentWillReceiveProps(nextProps) {
    if (this.state.loading !== nextProps.loading) {
      this.setState({ loading: nextProps.loading });
    }
    /*if (
      this.state.loading !== nextProps.loading ||
      this.state.data !== nextProps.data
    ) {
      this.setState({
        loading: nextProps.loading,
        data: nextProps.data
      });
    }*/
  }
  isStatusCalledDone(status) {
    const statusCode = parseInt(status)
    return 7 == statusCode
  }
  shouldComponentUpdate(nextProps, nextState) {
    return (
      nextState.callDoneRequest !== this.state.callDoneRequest ||
      nextState.callDoneSending !== this.state.callDoneSending ||
      nextState.loading !== this.state.loading ||
      nextProps.data !== this.props.data ||
      nextState.filtered !== this.state.filtered ||
      nextState.sorted !== this.state.sorted
    );
  }

  selectFilterMethod = (filter, row) => {
    if (filter.value === "all") {
      return true;
    }    
    if (filter.id === "company") { 
      const _selectedCompany = this.props.companies.find(c => c.name === filter.value);
      this.setState({ selectedCompany: _selectedCompany })
    }
    return row[filter.id] === filter.value;
  };

  numberFilterMethod = numberFilterMethod;
  userIdFilterMethod = userIdFilterMethod;
  selectFilterMethodInt = selectFilterMethodInt;
  dateSort = dateSort;
  getPlanningUserIdOptions = planningUserIdOptions;
  getStatusOptions = statusOptions;
  getSectionOptions = sectionOptions;
  getCompanyOptions = companyOptions;
  getPlanningUserLabel(userId) {
    //console.log(this.props.planningUsers);
    if (this.props.planningUsers !== null) {
      //console.log("Je rentre");
      const ret = this.props.planningUsers.find((planningUser) => planningUser.value === userId);
      if (ret) {
        return ret.label;
      }
      return userId;
    }
    
    //const res = this.props.planningUsers.find((planningUser) => planningUser.value === userId);
    //return res;
    return "";
  }
  resend = (event, requestId) => {
    event.preventDefault();

    axios
      .post(`/requests/${requestId}/resend`)
      .then(response => {
        if (response.data && response.data.status === 201) {
          toast.success("Relance envoyée");
        } else {
          toast.error("Problème lors de la relance");
        }
      })
      .catch(error => {
        toast.error("Problème lors de la relance");
      });
  };
  
  removeRowHandler = (event, row) => {
    event.preventDefault();
    this.props.removeRowHandler(row.original);
  };

  reloadData = () => {
    //console.log("reload Data 1", Date.now())
    this.props.reloadData();
  };

  switchHandler = (event, requestId) => {
    //var state = this.state;
    event.preventDefault();

    axios
      .post(`/requests/${requestId}/billed`)
      .then(response => {
        if (response.data && response.data.status === 202) {
          const { result } = response.data;
          toast.success("Mise a jour ok");
          this.props.onPatchRequest(result.id, { billed: result.billed });
          
          /*let _data = this.state.data;
          
          _data = _data.map(request =>
            request.id === result.id
              ? { ...request, billed: result.billed }
              : request
          );
          this.setState({data : _data})*/
    
        } else {
          toast.error("Problème lors de mise à jour");
        }
      })
      .catch(error => {
        toast.error("Problème lors de la mise à jour : " + error);
      });
    
  };

  // « Appel fait » : on demande confirmation (texte du mail modifiable) avant de
  // passer en « Message laissé » et d'envoyer le mail aux contacts.
  switchStatus = (event, request) => {
    event.preventDefault();
    this.setState({ callDoneRequest: request });
  };

  cancelCallDone = () => {
    if (this.state.callDoneSending) return;
    this.setState({ callDoneRequest: null });
  };

  confirmCallDone = (message, enLigne) => {
    const request = this.state.callDoneRequest;
    if (!request) return;
    this.setState({ callDoneSending: true });
    // 04/11/2026 (registre n° 39) : lien « Répondre en ligne » ajouté au mail si la case est cochée
    (enLigne
      ? lienFil(request.id).then((j) => j.url).catch(() => {
          toast.warn("Lien « Répondre en ligne » indisponible : le mail part sans lien");
          return null;
        })
      : Promise.resolve(null))
      .then((replyUrl) => axios.post(`/requests/${request.id}/call-done`, replyUrl ? { message, replyUrl } : { message }))
      .then((response) => { rafraichirEtats(); return response; })
      .then(response => {
        if (response.data && response.data.status === 202) {
          const { result } = response.data;
          if (response.data.message && response.data.message.indexOf("mail error") >= 0) {
            toast.warn("Statut mis à jour, mais le mail n'est pas parti : " + response.data.message);
          } else {
            toast.success("Message laissé — mail envoyé au client");
          }
          this.props.onPatchRequest(result.id, { status: result.status });
        } else {
          toast.error("Problème lors de mise à jour");
        }
        this.setState({ callDoneRequest: null, callDoneSending: false });
      })
      .catch(error => {
        toast.error("Problème lors de la mise à jour");
        this.setState({ callDoneSending: false });
      });
  };


  downloadRequestFile = (e, request) => {
    if (null !== e) e.preventDefault();
    //console.log(request);
    const sortFiles = request.interventionFiles.sort((a, b) => b.id - a.id);
    const file = sortFiles[0];
    axios({
      url: "/requests/" + request.id + "/download/" + file.id,
      method: "GET",
      responseType: "blob"
    }).then(response => {
      if (response.data) {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", file.fileName);
        document.body.appendChild(link);
        link.click();
      } else {
        toast.error("Erreur lors du chargement du bon");
      }
    });
  };

  getColumnsMemo = (companies) => {
    const key = JSON.stringify({ len: companies.length, ids: companies.map(c => c.id) });
    if (this.columnsCache && this.lastCompaniesKey === key) return this.columnsCache;
    this.columnsCache = this.buildColumns(companies); // ex- getColumns
    this.lastCompaniesKey = key;
    return this.columnsCache;
  }

  buildColumns = companies => {
    console.log("Render columns", Date.now());
    var columns = [];
    //First Col : Number of intervention
    if (isA() || isReporter()) {
      columns.push({
        Header: "Numéro", className: "atis-col-num", headerClassName: "atis-col-num", // ATIS-HABILLAGE-A
        accessor: "id",
        filterable: true,
        width: 100,
        maxWidth: 100,
        sortable: true,
        resizable: false,
        filterMethod: (filter, row) => this.numberFilterMethod(filter, row),
        Cell: row => (
          <div style={{ textAlign: "center"}}>{row.value}</div>
        )
      });
    } else {
      columns.push({
        Header: "",
        accessor: "id",
        filterable: false,
        sortable: true,
        width: 20,
        maxWidth: 20,
        resizable: false,
        Cell: row => null
      });
    }
    //Second Col : Label of intervention
    columns.push({ Header: "Intitulé", className: "atis-col-titre", headerClassName: "atis-col-titre", accessor: "name", filterable: false });
    //Third Col : Company or Section or Nothing
    if (companies.length > 1 && (isA() || isReporter())) {
      columns.push({
        Header: "Client", className: "atis-col-client", headerClassName: "atis-col-client",
        accessor: "company",
        id: "company",
        filterMethod: (filter, row) => this.selectFilterMethod(filter, row),
        Filter: ({ filter, onChange }) => 
          <select
            onChange={event => onChange(event.target.value)}
            style={{ width: "100%" }}
            value={filter ? filter.value : "all"}
          >
            {this.getCompanyOptions(companies)}
          </select>,
        Cell: row => row.original.company
      });
      columns.push({
        Header: "Site", className: "atis-col-site", headerClassName: "atis-col-site",
        accessor: "section",
        filterMethod: (filter, row) => this.selectFilterMethod(filter, row),
        Filter: ({ filter, onChange }) =>
        <select
          onChange={event => onChange(event.target.value)}
          style={{ width: "100%" }}
          value={filter ? filter.value : "all"}
        >
          {siteFilterOptions(this.props.companies, this.state.filtered, filter ? filter.value : "all")}
          
        </select>,
        Cell: row => row.original.section
      });
    } else if (
      companies.length === 1 &&
      companies[0] &&
      companies[0].sections.length > 0
    ) {
      if (companies[0].sections.length > 1) {
        columns.push({
          Header: "Site", className: "atis-col-site", headerClassName: "atis-col-site",
          accessor: "section",
          filterMethod: (filter, row) => this.selectFilterMethod(filter, row),
          Filter: ({ filter, onChange }) => <select
            onChange={event => onChange(event.target.value)}
            style={{ width: "100%" }}
            value={filter ? filter.value : "all"}
          >
            {this.getSectionOptions(companies[0])}
          </select>
        });
      } else {
        columns.push({
          Header: "Site", className: "atis-col-site", headerClassName: "atis-col-site",
          accessor: "section",
          filterable: false,
        });
      }
    }
    //Created on
    columns.push({
      Header: "Créée le", className: "atis-col-cree", headerClassName: "atis-col-cree",
      accessor: "createdAt",
      filterable: false,
      width: 90,
      maxWidth: 90,
      sortMethod: (a, b) => this.dateSort(a, b),
      Cell: row => (
        <div style={{ textAlign: "center"}}>{row.value}</div>
      )
    });
    //planned section
    columns.push({
      Header:"Plannifiée le", className: "atis-col-planif", headerClassName: "atis-col-planif",
      accessor: "predictedAt",
      filterable:false,
      width:90,
      maxWidth:90,
      sortMethod: (a, b) => this.dateSort(a,b),
      Cell: row => (
        <div style={{ textAlign: "center"}}>{row.value}</div>
      )
    });
    if (isA() || isReporter()) {
      columns.push({
        Header: "Intervenant", className: "atis-col-interv", headerClassName: "atis-col-interv",
        accessor: "requestPlanning",
        filterable: true,
        sortable: true,
        width: 150,
        maxWidth: 150,
        filterMethod: (filter, row) => this.userIdFilterMethod(filter, row),
        Filter: ({ filter, onChange }) => 
          <select
            onChange={event => onChange(event.target.value)}
            style={{ width: "100%" }}
            value={filter ? filter.value : "all"}
          >
            {this.getPlanningUserIdOptions(this.props.planningUsers)}
          </select>,
        Cell: row =>  row.original.requestPlanning ? this.getPlanningUserLabel(row.original.requestPlanning.userId) : ""
      });
    }
    columns.push({
      Header: "Statut", className: "atis-col-statut", headerClassName: "atis-col-statut",
      accessor: "status",
      filterable: true,
      sortable: true,
      width: 120,
      maxWidth: 120,
      filterMethod: (filter, row) => this.selectFilterMethodInt(filter, row),
      Filter: ({ filter, onChange }) =>
        <select
          onChange={event => onChange(event.target.value)}
          style={{ width: "100%" }}
          value={filter ? filter.value : "all"}
        >
          {this.getStatusOptions()}
        </select>,
      Cell: row => (
        <React.Fragment>
        <CellStatus
          requestStatus={row.value}
          align="center"
          requestHasPdf={row.original.hasPdf && row.original.status === 1}
        />
        {isA() ? <FilBadge requestId={row.original.id} /> : null}
        </React.Fragment>
      )
    });
    columns.push({
      Header: "",
      accessor: "",
      filterable: false,
      sortable: false,
      width: 70,
      maxWidth: 70,
      className: "atis-col-fiche", headerClassName: "atis-col-fiche",
      Cell: row => (
        <div align="center">
          <Tooltip title="Afficher la demande d'intervention" position="bottom">
            <Link
              to={`/requests/${row.original.id}`}
              replace={true}
              style={{ cursor: "pointer" }}
            >
              <span className="fa fa-list-alt" />
            </Link>
          </Tooltip>
        </div>
      )
    });
    if (isA() || isReporter()) {
      columns.push({
        Header: "Appel fait", className: "atis-col-appel", headerClassName: "atis-col-appel",
        accessor: "",
        filterable: false,
        sortable: true,
        width: 80,
        maxWidth: 100,
        Cell: row => row.original.status == 0  || row.original.status == 7 ? (
              <label className="switch">
              <FormControl
                id="callDone"
                type="checkbox"
                onChange={(event) => this.switchStatus(event, row.original)}
                checked={this.isStatusCalledDone(row.original.status)}
                disabled={this.isStatusCalledDone(row.original.status)}
              />
              <em />
            </label>
          ) : null
        },
        {
        Header: "Facturée", className: "atis-col-facture", headerClassName: "atis-col-facture",
        accessor: "billed",
        filterable: false,
        sortable: true,
        width: 80,
        maxWidth: 100,
        Cell: row => (
          <label className="switch">
            <FormControl
              id="billed"
              type="checkbox"
              onChange={(event) => this.switchHandler(event, row.original.id)}
              checked={row.original.billed}
            />
            <em />
          </label>
          )
      },
      {
        Header: "",
        accessor: "",
        filterable: false,
        sortable: false,
        width: 70,
        maxWidth: 70,
        className: "atis-col-act", headerClassName: "atis-col-act",
        Cell: row => (
          <div align="center" style={{ cursor: "pointer" }}>
            {row.original.status === 0 || row.original.status === 4 ? (
              <span
                className={row.original.deleted ? "fa fa-history" : "fa fa-trash"}
                onClick={event => this.removeRowHandler(event, row)}
              />
            ) : row.original.status === 1 && row.original.hasPdf && row.original.interventionFiles.length > 0 ? (
              <span
                onClick={event => this.downloadRequestFile(event, row.original)}
              >
                <i className="fa fa-paperclip" />
              </span>
            ) : row.original.status === 5 && row.original.hasPdf && row.original.interventionFiles.length > 0 ? (
              <span
                onClick={event => this.downloadRequestFile(event, row.original)}
              >
                <i className="fa fa-paperclip" />
              </span>
            ) : row.original.status === 3 && row.original.hasPdf && row.original.interventionFiles.length > 0 ? (
              <Tooltip title="Compte-rendu disponible" position="bottom">
                <span>
                  <i style={{ 'color': 'green', 'fontWeight' : 'bold'}} className="fa fa-paperclip" />
                </span>
              </Tooltip>
            ) : null}
          </div>
        )
      });
    } else {
      columns.push({
        Header: "",
        accessor: "",
        filterable: false,
        sortable: false,
        width: 70,
        maxWidth: 70,
        className: "atis-col-act", headerClassName: "atis-col-act",
        Cell: row => (
          <div align="center" style={{ cursor: "pointer" }}>
            {row.original.status === 3 ? (
              <Tooltip title="Répondre à la planification" position="bottom">
                <Link
                  to={`/requests/${row.original.id}/response`}
                  replace={false}
                >
                  <span className="fa fa-reply" />
                </Link>
              </Tooltip>
            ) : row.original.status === 0 ? (
              <Tooltip title="Relancer" position="bottom">
                <span
                  className="fa fa-history"
                  onClick={event => this.resend(event, row.original.id)}
                  style={{ mouse: "cursor" }}
                />
              </Tooltip>
            ) : row.original.status === 1 &&
              row.original.hasPdf &&
              row.original.interventionFiles.length > 0 ? (
              <span
                onClick={event => this.downloadRequestFile(event, row.original)}
              >
                <i className="fa fa-paperclip" />
              </span>
            ) : null}
          </div>
        )
      });
    }
    return columns;
  };

  render() {
    const { loading, filtered, sorted } = this.state;
    const {data} = this.props;
    console.log('Render Table', data)
    let companies = this.props.companies;
    if (companies.length === 0) {
      companies.push(this.props.company);
    }
    console.log('reactTable load data: ', data)
    
    console.log(data.length)
    if (loading) {
      return <div>Chargement…</div>;
    }

    if (!loading && data.length === 0) {
      return <div>Aucune donnée</div>;
    }

    const columns = this.getColumnsMemo(companies)
    //console.log("filtered = ", filtered);
    return (
      <React.Fragment>
        <ReactTable
          defaultFilterMethod={(filter, row) => {
              String(row[filter.id]) === filter.value
            }
          }
          onFilteredChange={(filterArr) => {
              sessionStorage.setItem("requestFilters", JSON.stringify(filterArr));
              this.setState({filtered:filterArr});
            }
          }
          onSortedChange={(sortArr) => {
              sessionStorage.setItem("requestSorts", JSON.stringify(sortArr));
              this.setState({sorted:sortArr});
            } 
          }
          columns={columns}
          filterable 
          filtered={filtered}
          sortable
          sorted={sorted}
          data={data}
          style={{
            height: "calc(100vh - 300px)",
            minHeight: "420px"
          }}
          minRows={0}
          loading={loading}
          className="-striped -highlight"
        />
        <CallDoneModal
          show={this.state.callDoneRequest !== null}
          request={this.state.callDoneRequest}
          sending={this.state.callDoneSending}
          onConfirm={this.confirmCallDone}
          onCancel={this.cancelCallDone}
        />
        <ToastContainer
          position="bottom-right"
          autoClose={3000}
          hideProgressBar
          newestOnTop
          closeOnClick
          rtl={false}
          pauseOnVisibilityChange
          draggable
          pauseOnHover={false}
        />
      </React.Fragment>
    );
  }
}
/*<CellIcons row={row} editRequestHandler={this.props.editRequestHandler} />*/
export default RequestTable;



// WEBPACK FOOTER //
// ./src/components/UI/Widget/RequestTable.js